import React from 'react';
import { Summary } from '../Summary';
import { useOneReveal } from './one-reveal-machine';

export function OneReveal() {
  const [state, send] = useOneReveal();

  let currentStage: 'colors' | 'properties' | 'revealed';
  if (
    state.matches('colorReveal') ||
    state.matches('colorsRevealed') ||
    state.matches('colorsRevealing')
  ) {
    currentStage = 'colors';
  } else if (
    state.matches('propertyReveal') ||
    state.matches('propertiesRevealed') ||
    state.matches('propertiesRevealing')
  ) {
    currentStage = 'properties';
  } else {
    currentStage = 'revealed';
  }

  const currentStageRevealed =
    state.matches('propertiesRevealed') || state.matches('colorsRevealed');

  return (
    <Summary
      currentGribble={state.context.gribble}
      next={() => send('next')}
      gribbleCount={1}
      prev={() => null}
      last={state.matches('everythingRevealed')}
      revealAll={() => send('revealAll')}
      currentStageRevealed={currentStageRevealed}
      revealOne={(id: string) => send({ type: 'revealOne', id })}
      finish={() => send('finish')}
      stage={currentStage}
    />
  );
}
